import { ActiveDevice, DeviceList } from "@domain";
import { StreamSourceType } from "@domain";

export interface LocalVideoState {
  devices: DeviceList;
  selectedDevice: ActiveDevice;
  loading: boolean;
  currentSourceType: StreamSourceType | null; // Tipo di source attiva (camera o screen)
}

export const defaultLocalVideoState: LocalVideoState = {
  devices: DeviceList.create(),
  selectedDevice: ActiveDevice.createEmpty(),
  loading: false,
  currentSourceType: null
};
